import { render, staticRenderFns } from "./PartnersResourceCreate.vue?vue&type=template&id=6d153106"
import script from "./PartnersResourceCreate.vue?vue&type=script&lang=js"
export * from "./PartnersResourceCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports